module.exports = __webpack_public_path__ + "static/img/popup_communication@3x.56cd466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup_communication@3x.png
// module id = sTTS
// module chunks = 1